import { render, staticRenderFns } from "./tzgzMb.vue?vue&type=template&id=83f29dee&scoped=true&"
import script from "./tzgzMb.vue?vue&type=script&lang=js&"
export * from "./tzgzMb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f29dee",
  null
  
)

export default component.exports